import { foldersDeletableItemDisplayText, genericDeletableItemDisplayText } from './constants';
import { DeletableItem, DeletableItemDisplayText } from './types';

/**
 * Get the display text that corresponds to the type/quantity of `items` provided
 * to the `<DeleteItemsModal />` component.
 */
export const getItemsDisplayText = (
  content: DeletableItem[],
  folders: DeletableItem[],
  displayTextForContentItems: DeletableItemDisplayText,
) => {
  if (content.length && folders.length) {
    // Deleting both folder and content item(s) - use the generic display text
    return genericDeletableItemDisplayText;
  } else if (folders.length) {
    // Deleting just folder item(s) - use folder-specific display text
    return foldersDeletableItemDisplayText;
  }
  // Deleting just content item(s) - use provided display text
  return displayTextForContentItems;
};

/**
 * Get the lowercase noun describing the items being deleted, pluralized based on quantity, given
 * the `items` provided to the `<DeleteItemsModal />` component.
 *
 * ex: "template", "campaigns", "folder", "items"
 */
export const getItemsTypeName = (
  content: DeletableItem[],
  folders: DeletableItem[],
  displayTextForContentItems: DeletableItemDisplayText,
) => {
  const singularOrPlural = content.length + folders.length > 1 ? 'plural' : 'singular';
  return getItemsDisplayText(content, folders, displayTextForContentItems).itemTypeName[
    singularOrPlural
  ];
};

/**
 * Get the lowercase verb describing deletion given the type of `items` provided to the
 * `<DeleteItemsModal />` component.
 *
 * ex: "archive", "delete"
 */
export const getItemsDeletionVerb = (
  content: DeletableItem[],
  folders: DeletableItem[],
  displayTextForContentItems: DeletableItemDisplayText,
) => getItemsDisplayText(content, folders, displayTextForContentItems).actionName.verb;
